export default "__VITE_ASSET__abc1f4a2__"